// extracted by mini-css-extract-plugin
export default {"container":"FramedStatus_container__ydxrz","roundedIcon":"FramedStatus_roundedIcon__3SOMQ"};